export enum ConditionState
{
    Incomplete = 0,
    UpToDate = 1, // Anything greater than this is considered to be needing attention
    Due = 2,
    Overdue = 3,
    Critical = 4 // Means that there was a warning from the Health Monitor
}

export namespace ConditionState
{
    export function toString( state: ConditionState )
    {
        switch( state )
        {
            case ConditionState.Critical: return "High priority";
            case ConditionState.Overdue: return "Overdue";
            case ConditionState.Due: return "Coming up";
            case ConditionState.UpToDate: return "Healthy";
            default: return "Not set";
        }
    }
}